import React from 'react';
import { Steps as AntSteps, ConfigProvider } from 'antd';
import classNames from 'classnames';

/**
 * A wrapper component around AntDesign's Steps component with additional styling options
 * @module Steps
 * 
 * {@link https://ant.design/components/steps#api Ant Design Steps}
 * 
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child elements to render within the steps
 * @param {boolean} [props.hidePipe] - Whether to hide the connecting line between steps
 * @param {string} [props.className] - Additional CSS class name
 * @param {boolean} [props.darker] - Whether to use darker styling
 * @param {string} [props.size] - Size of the steps ('mini' | 'small' | 'default'). Mini size uses vertical label placement and reduced description width
 * @returns {React.ReactElement} Rendered Steps component
 */

const Steps = ( props ) => {
    const { children, hidePipe, className, darker, size, ...restProps } = props;
    const stepsClasses = classNames( {
        'steps': true,
        'hide-pipe': hidePipe,
        [ className ]: className ? className : false,
        'darker': darker ? darker : false,
        [ size || 'default' ]: true
    } );
    if ( size === 'mini' ) {
        return (
            <ConfigProvider
                theme={ {
                    components: {
                        Steps: {
                            descriptionMaxWidth: 40
                        },
                    },
                } }
            >
                <AntSteps responsive={ false } { ...restProps } labelPlacement='vertical' className={ stepsClasses }>{ children }</AntSteps>
            </ConfigProvider>
        );
    }
    return (
        <AntSteps responsive={ false } { ...restProps } labelPlacement='vertical' className={ stepsClasses }>{ children }</AntSteps>
    );
};

export { Steps };
